export const mockCalculatePaymentAmount = {
  success: true,
  paymentAmountNeeded: 3500,
  isApp: false,
  userID: 2,
};
